import { IRequestsState } from "./reducer";

export interface IWithRequestsState {
  requests: IRequestsState;
}

export const createRequestFetchingSelector =
  (actions: string[]) =>
  // @ts-expect-error TS(2322): Type 'undefined' is not assignable to type 'boolea... Remove this comment to see the full error message
  (state: IWithRequestsState, successful: boolean = undefined): boolean =>
    actions.some(action => {
      const request = state.requests[action];

      if (successful === true) {
        return request && request.isFetching === false && request.error === undefined;
      }
      if (successful === false) {
        return request && request.isFetching === false && request.error !== undefined;
      }
      return request && request.isFetching;
    });

export const createRequestErrorSelector =
  (actions: string[]) =>
  (state: IWithRequestsState): string =>
    actions
      .reduce(
        (acc: string[], action: string) =>
          state.requests[action] && state.requests[action].error ? [...acc, state.requests[action].error] : acc,
        []
      )
      .join(", ");

export const createHasFetchedSelector =
  (actions: string[]) =>
  (state: IWithRequestsState): boolean =>
    actions.some(
      action => state.requests[action] && !state.requests[action].isFetching && !state.requests[action].error
    );
